import { UIText2 } from '@cian/ui-kit';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './UndergroundStations.css';
import { IDailyRentOfferForMobileSite } from '../../../../repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import { GeoTravelTime } from '../GeoTravelTime';
import { UndergroundIcon } from '../UndergroundIcon';

export const UndergroundStations = (props: Pick<IDailyRentOfferForMobileSite, 'geo'>) => {
  const { geo } = props;
  const { undergrounds, regionId } = geo;

  const station = undergrounds.length ? undergrounds[0] : null;

  if (!station) {
    return null;
  }

  const { id, underConstruction, lineColor, name, time, transportType } = station;

  return (
    <div key={id} className={cn(styles['container'], { [styles['container_under-construction']]: underConstruction })}>
      {lineColor && <UndergroundIcon className={styles['icon']} color={`#${lineColor}`} regionId={[regionId]} />}
      <span className={styles['name']}>
        <UIText2 display="inline" color="text-primary-default">
          {name}
        </UIText2>
      </span>
      {time && transportType && <GeoTravelTime time={time} transportType={transportType} />}
    </div>
  );
};
